import type { PageHelp } from "../../help/types";

export const employerHelp: PageHelp = {
  title: "Employer",
  intro:
    "Information your employer shares with all employees in the benefit programme. Today that is a list of documents — rules, policy conditions, forms — that you can open and download.",
  sections: ["Getting around the page", "Documents"],
  tips: [
    "These documents are the same for every employee of your employer. Your own documents are on your profile, under Documents.",
  ],
  steps: [
    {
      selector: '[data-help="employer-tab-details"]',
      title: "Employer details",
      body: "Reserved for details about your employer. It is greyed out because this part of the page is not available yet.",
      section: "Getting around the page",
    },
    {
      selector: '[data-help="employer-tab-documents"]',
      title: "Show your employer's documents",
      body: "Opens the list of documents your employer has shared. This tab is selected when you arrive on the page.",
      section: "Getting around the page",
    },
    {
      selector: '[data-help="employer-documents"]',
      title: "Browse the documents",
      body: "Every document your employer has shared, with the date it was last uploaded or changed. A recent date usually means the document was updated — worth a second read.",
      section: "Documents",
      optional: true,
    },
    {
      selector: '[data-help="employer-document-open"]',
      title: "Open a document",
      body: "Click the document name to open it in a new browser tab, where you can read, download or print it. The icon shows the file type.",
      section: "Documents",
      optional: true,
    },
    {
      selector: '[data-help="employer-no-documents"]',
      title: "No documents yet",
      body: "Shown when your employer has not shared any documents. Nothing is missing on your side; check back later or ask your HR contact.",
      section: "Documents",
      optional: true,
    },
  ],
};
